export default __webpack_public_path__ + "static/media/people@2x.025e71c2.jpg";